// Sprint chatgpt-message-rail (D6) — single owner of the id -> DOM jump.
// Byte-equivalent to the body `ConversationSearch.tsx`'s `jumpTo` used to
// inline (`:99-104` pre-sprint); that function now delegates here instead
// of keeping its own copy. Both the rail (`MessageRail.tsx`) and the
// search row call this — one behaviour, one place to fix it.
//
// No in-place highlight of the destination message (valla
// `fc-conversation-search` §10.4 — the message renderers are not edited by
// this sprint).

export function jumpToMessage(root: Element | null, id: string): void {
  root
    ?.querySelector(`[data-message-id="${id}"]`)
    ?.scrollIntoView({ block: 'center', behavior: 'smooth' });
}
